import * as Y from 'yjs';
import { assertNonNull } from '../utils';
import { SafeSpace } from '../types';

export default function getYDocFromSafeSpace(space: SafeSpace): Y.Doc {
    const yDoc = space.map.doc;
    assertNonNull(yDoc, 'getYDocFromSafeSpace: Y.Doc of safeSpace must not be null');
    return yDoc;
}
